import { ApolloCache } from '@apollo/client/core';
import { ProjectDocument, ProjectQuery, ProjectQueryVariables } from '@/graphql/operations.gen';

const updateProjectCache = (
  cache: ApolloCache<any>,
  id: string,
  updateFn: (project: ProjectQuery['project']) => Partial<ProjectQuery['project']>
) => {
  const cacheData = cache.readQuery<ProjectQuery, ProjectQueryVariables>({
    query: ProjectDocument,
    variables: { id },
  });

  cache.writeQuery<ProjectQuery, ProjectQueryVariables>({
    query: ProjectDocument,
    data: {
      project: {
        ...cacheData.project, // Shallow copy all existing data
        ...updateFn(cacheData.project), // spread all updated prop
      },
    },
    variables: {
      id,
    },
  });
};

export default updateProjectCache;
